import { useCallback } from 'react'

import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId } from '@/models/creators.ts'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider'
import { handleError } from '@/utils/error'

import { aiSettingsService } from '../../service/ai-settings-service'

export const useAiTranslatorToggle = () => {
  const creatorId = useUnit($creatorId)
  const { aiTranslationEnabled: enabled, setSettingsData } =
    useSettingsContext()

  const enableAiTranslator = useMutation((data: { state: boolean }) =>
    aiSettingsService.toggleAiTranslator(creatorId!, data),
  )

  const toast = useToast()

  const handleEnabledChange = useCallback(
    async () => {
      try {
        const value = !enabled

        await enableAiTranslator.mutateAsync({
          state: value,
        })

        setSettingsData((prevState) => ({
          ...prevState,
          aiTranslationEnabled: value,
        }))

        const stateLabel = value ? 'enabled' : 'disabled'

        toast.success(`Successfully ${stateLabel} AI translator`)
      } catch (error) {
        handleError(error, 'Something went wrong. Try again later!')
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [enabled, setSettingsData],
  )

  return { enabled, onToggle: handleEnabledChange }
}
